<template>
  <div>
    <h1>Contacto</h1>
    <h3>Mis redes sociales</h3>
    <p><a href="https://twitter.com/_AngelGuerrero_">@_AngelGuerrero_</a> </p>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

